import { render } from "./OurSectors.vue?vue&type=template&id=4be40e89"
import script from "./OurSectors.vue?vue&type=script&lang=js"
export * from "./OurSectors.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__